<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.hospitalisations', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form  @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="institution-group"
                                        :label="$t('message.institutionConsultation')"
                                        label-for="institution"
                                >
                                    <select id="institution" v-model="$v.form.etablissement_id.$model"
                                            @change="clearErrorField('etablissement_id')"
                                            required
                                            class="form-control is-invalid retirerBordure"
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mInstitutions" :key="item.id" :value="item.id">
                                            {{ item.nom }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.etablissement_id.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('etablissement_id')" style="color:red">
                                    {{getErrorsField('etablissement_id')}}
                                    </span>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="singleMotif-group"
                                        :label="$tc('message.reasons', 2)"
                                        label-for="singleMotif"
                                >
                                    <select id="singleMotif" v-model="$v.motifs.$model" multiple
                                            @change="clearErrorField('motifs')"
                                            class="form-control is-invalid retirerBordure"
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mReasons" :key="item.value" :value="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.motifs.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('motifs')" style="color:red">
                                    {{getErrorsField('motifs')}}
                                    </span>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="entree-group"
                                        :label="$t('message.entryDate')"
                                        label-for="entree"
                                        description="">
                                    <b-form-input
                                            id="entree"
                                            v-model="$v.form.date_entree.$model"
                                            :state="$v.form.date_entree.$dirty ? !(errorshasField('date_entree') || $v.form.date_entree.$error) : null"
                                            type="date"
                                            required
                                            @focus="clearErrorField('date_entree')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.date_entree.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('date_entree')">
                                        {{ getErrorsField('date_entree') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="sortie-group"
                                        :label="$t('message.exitDate')"
                                        label-for="sortie"
                                        description="">
                                    <b-form-input
                                            id="entree"
                                            v-model="$v.form.date_sortie.$model"
                                            :state="$v.form.date_sortie.$dirty ? !(errorshasField('date_sortie') || $v.form.date_sortie.$error) : null"
                                            type="date"
                                            @focus="clearErrorField('date_sortie')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('date_sortie')">
                                        {{ getErrorsField('date_sortie') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="histoire-group"
                                        :label="$t('message.clinicalHistory')"
                                        label-for="histoire"
                                >
                                    <editor
                                            :api-key="tinyKey"
                                            id="histoire"
                                            v-model="$v.form.histoire_clinique.$model"
                                            :state="$v.form.histoire_clinique.$dirty ? !(errorshasField('histoire_clinique') || $v.form.histoire_clinique.$error) : null"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('histoire_clinique')"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback v-if="!$v.form.histoire_clinique.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="histoireClinque" class="obligatoire2">
                                        {{ $t('message.requiredField') }}
                                    </span>
                                    <b-form-invalid-feedback v-else-if="errorshasField('histoire_clinique')">
                                        {{ getErrorsField('histoire_clinique') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="lifestyle-group"
                                        :label="$t('message.lifestyle')"
                                        label-for="lifestyle"
                                >
                                    <editor
                                            :api-key="tinyKey"
                                            id="lifestyle"
                                            v-model="$v.form.mode_de_vie.$model"
                                            :state="$v.form.mode_de_vie.$dirty ? !(errorshasField('mode_de_vie') || $v.form.mode_de_vie.$error) : null"

                                            placeholder=""
                                            @focus="clearErrorField('mode_de_vie')"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback v-if="errorshasField('mode_de_vie')">
                                        {{ getErrorsField('mode_de_vie') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group
                                        id="clinique-group"
                                        :label="$tc('message.physicalExams', 2)"
                                        label-for="clinique"
                                >
                                    <editor
                                            :api-key="tinyKey"
                                            id="clinique"
                                            v-model="$v.form.examen_clinique.$model"
                                            :state="$v.form.examen_clinique.$dirty ? !(errorshasField('examen_clinique') || $v.form.examen_clinique.$error) : null"
                                            rows="5"
                                            @focus="clearErrorField('examen_clinique')"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback v-if="errorshasField('examen_clinique')">
                                        {{ getErrorsField('examen_clinique') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="complementaire-group"
                                        :label="$tc('message.complementaryExams', 2)"
                                        label-for="complementaire"
                                >
                                    <editor
                                            :api-key="tinyKey"
                                            id="complementaire"
                                            v-model="$v.form.examen_complementaire.$model"
                                            :state="$v.form.examen_complementaire.$dirty ? !(errorshasField('examen_complementaire') || $v.form.examen_complementaire.$error) : null"
                                            rows="5"
                                            @focus="clearErrorField('examen_complementaire')"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback v-if="errorshasField('examen_complementaire')">
                                        {{ getErrorsField('examen_complementaire') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="conclusion-group"
                                        :label="$t('message.conclusion')"
                                        label-for="conclusion">
                                    <editor
                                            :api-key="tinyKey"
                                            id="conclusion"
                                            v-model="$v.form.conclusion.$model"
                                            :state="$v.form.conclusion.$dirty ? !(errorshasField('conclusion') || $v.form.conclusion.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('conclusion')"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback v-if="errorshasField('conclusion')">
                                        {{ getErrorsField('conclusion') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                          <b-col sm="12">
                            <b-form-group
                                id="evolution-group"
                                :label="$t('message.evolution')"
                                label-for="evolution">
                              <editor
                                  :api-key="tinyKey"
                                  id="evolution"
                                  v-model="$v.form.evolution.$model"
                                  :state="$v.form.evolution.$dirty ? !(errorshasField('evolution') || $v.form.evolution.$error) : null"
                                  placeholder=""
                                  @focus="clearErrorField('evolution')"
                                  :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                              >
                              </editor>

                              <b-form-invalid-feedback v-if="errorshasField('evolution')">
                                {{ getErrorsField('evolution') }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group
                                        id="avis-group"
                                        :label="$t('message.avis')"
                                        label-for="avis"
                                >
                                    <editor
                                            :api-key="tinyKey"
                                            id="avis"
                                            v-model="$v.form.avis.$model"
                                            :state="$v.form.avis.$dirty ? !(errorshasField('avis') || $v.form.avis.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('avis')"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback v-if="errorshasField('avis')">
                                        {{ getErrorsField('avis') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="traitement-group"
                                        :label="$t('message.exitTreatment')"
                                        label-for="traitement"
                                >
                                    <editor
                                            :api-key="tinyKey"
                                            id="traitement"
                                            v-model="$v.form.traitement_sortie.$model"
                                            :state="$v.form.traitement_sortie.$dirty ? !(errorshasField('traitement_sortie') || $v.form.traitement_sortie.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('traitement_sortie')"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback v-if="errorshasField('traitement_sortie')">
                                        {{ getErrorsField('traitement_sortie') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="rendez-group"
                                        :label="$t('message.appointmentDate')"
                                        label-for="consultation"
                                        description="">
                                    <vue-ctk-date-time-picker class="border-dark" v-model="$v.form.rendez_vous.$model"></vue-ctk-date-time-picker>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="traitement-appointmentReason-group"
                                        :label="$t('message.appointmentReason')"
                                        label-for="appointmentReason"
                                >
                                    <editor
                                            :api-key="tinyKey"
                                            id="appointmentReason"
                                            v-model="$v.form.rdv.motif.$model"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>
                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-button @click="onSubmit" variant="primary" v-if="form.isAuthor || hasAdminRole">
                                {{ $t('message.edit') }}
                            </b-button>

<!--                            <b-button type="reset" variant="danger" v-if="form.isAuthor || hasAminRole">-->
<!--                                {{ $t('message.reset') }}-->
<!--                            </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import moment from "moment";
    import SlimSelect from "slim-select";
    import Editor from "@tinymce/tinymce-vue";
    import AppConfig from "../../constants/AppConfig";
    export default {
        name: "EditHospitalisation",
        components: {
            editor: Editor
        },
        computed: {
            ...mapGetters(["hospitalisation", "files","userInstitutions",
                'hasAdminRole', "errors" ,"reasons",]),

            mReasons:function(){
                let rArray = [];

                if (!_.isUndefined(this.reasons)){
                    _.forEach(this.reasons ,function (reason) {
                        rArray.push({text:reason.description, value : reason.id})
                    })
                    return rArray;
                }
                return  rArray;
            },

            mInstitutions: function() {
                let iArray = [];

                _.forEach(_.orderBy(this.userInstitutions,['created_at'],['desc']), function(institution) {
                    let i = {};

                    i.nom = institution.name;
                    i.description = (!_.isNull(institution.description)? institution.description.length > 20 : false) ? institution.description.substr(0, 20) + '...' : institution.description;
                    i.date = moment(institution.created_at).format('DD-MM-YYYY');
                    i.id = institution.id;
                    i.slug = institution.slug;

                    iArray.push(i);
                });

                return iArray;
            },
            form: function() {
                if (!_.isUndefined(this.hospitalisation.motifs)) {
                    let self = this;
                    let motifs = []
                    _.forEach(this.hospitalisation.motifs, function (h) {
                       motifs.push(h.id);
                    });
                    self.motifs = motifs;
                    self.motifsAEnvoyer = motifs;
                }
                let hospitalisation =  this.hospitalisation;
                if (_.isNull(hospitalisation.rdv)){
                    hospitalisation.rdv = [];
                    hospitalisation.rdv['date']='';
                    hospitalisation.rdv['motif']='';
                }
                return hospitalisation;
            },

            mFiles: function() {
                let sArray = [];

                _.forOwn(this.files, function(value, key) {
                    sArray.push({ text: value.numero_dossier, value: value.id });
                });

                return sArray;
            }
        },

        data() {
            return {
                tinyKey:AppConfig.tinyMceKey,
                plugins : [
                    'advlist autolink lists  image charmap',
                    'searchreplace visualblocks code fullscreen',
                    'print preview anchor insertdatetime media',
                    'paste code help wordcount table'
                ],
                toolbar : 'undo redo | formatselect | bold italic | \
                           alignleft aligncenter alignright | \
                           bullist numlist outdent indent | help',
                hospitalisation_id: this.$route.params.hospitalisation,
                show: true,
                motifs:[],
                motifsAEnvoyer:[],
                histoireClinque:false,
            }
        },
        watch:{
          motifs:function (oldValue,newValue) {
              // let self = this;
              // let premierIndex = -1;
              // let lastIndex = -1;
              // _.forEach(newValue,function (motif) {
              //     let premierIndex = _.findIndex( self.motifsAEnvoyer,function (valeur) {
              //           return valeur == motif;
              //     });
              //     if (premierIndex != -1){
              //         self.motifsAEnvoyer.splice(premierIndex,1);
              //     }else{
              //         self.motifsAEnvoyer.push(motif)
              //     }
              // });

          }
        },
        methods: {
            getUserInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getUserInstitutions', { args : args });
            },

            getReasons() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getReasons', { args : args });
            },

            getHospitalisation: function() {
                let args = {
                    hospitalisation: this.hospitalisation_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getHospitalisation', { args, errorMessages });
            },

            getMedicalFiles: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getMedicalFiles', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();
                if ((this.$v.form.histoire_clinique.$model).length == 0){
                    this.histoireClinque = true;
                }else{
                    this.histoireClinque = false;
                }
                this.$v.$touch();

                if(!this.$v.form.$invalid && !this.$v.motifs.$invalid) {
                    if (!_.isNull(this.form.dateRdv)){
                        this.form.rendez_vous = moment(this.form.rendez_vous).format('YYYY-MM-DD HH:mm');
                    }
                    let args = {
                        hospitalisation: this.hospitalisation_id,
                        dossier_medical_id: this.form.dossier_medical_id,
                        date_entree: this.form.date_entree,
                        date_sortie: this.form.date_sortie,
                        histoire_clinique: this.form.histoire_clinique,
                        mode_de_vie: this.form.mode_de_vie,
                        evolution: this.form.evolution,
                        examen_clinique: this.form.examen_clinique,
                        examen_complementaire: this.form.examen_complementaire,
                        conclusion: this.form.conclusion,
                        avis: this.form.avis,
                        traitement_sortie: this.form.traitement_sortie,
                        rendez_vous: this.form.rendez_vous,
                        etablissement_id: this.form.etablissement_id,
                        motifs:this.motifs,
                        motifRdv:this.form.rdv.motif
                    };

                    let successMessage = this.$i18n.t('message.hospitalisationUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateHospitalisation', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                /*evt.preventDefault();

                // Reset our form values
                this.form.dossier_medical_id = '';
                this.form.date_entree = '';
                this.form.date_sortie = '';
                this.form.histoire_clinique = '';
                this.form.mode_de_vie = '';
                this.form.evolution = '';
                this.form.examen_clinique = '';
                this.form.examen_complementaire = '';
                this.form.conclusion = '';
                this.form.avis = '';
                this.form.traitement_sortie = '';
                this.form.rendez_vous = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });*/
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                rdv:{
                  motif:{}
                },
                dossier_medical_id: {
                    required
                },

                etablissement_id:{
                    required
                },

                date_entree: {
                    required
                },
                date_sortie: {
                    //
                },
                histoire_clinique: {
                    required
                },
                mode_de_vie: {
                    //
                },
                evolution: {
                    //
                },
                conclusion: {
                    //
                },
                avis: {
                    //
                },
                traitement_sortie: {
                    //
                },
                rendez_vous: {
                    //
                },

                examen_clinique: {
                    //
                },

                examen_complementaire: {
                    //
                },
            },
            motifs:{
                required
            },

        },

        mounted() {
            // Fetch user institution list
            this.getUserInstitutions();

            // Retrieve hospitalisation
            this.getHospitalisation();

            // Retrieve list of medical files
            this.getMedicalFiles();

            // Fetch reason list
            this.getReasons();

            var  singleMotif  =  new SlimSelect({
                select: '#singleMotif',
                placeholder: 'Select or add reason',
                addable: function (value) {
                    if (singleMotif.selected().length == 5){
                        return false;
                    }
                    else{

                        // Return the value string
                        return value // Optional - value alteration // ex: value.toLowerCase()

                    }
                },
                limit:5

            });

            new SlimSelect({
                select: '#institution',
                placeholder: 'Select institution',
                limit:1
            });
        }
    }
</script>

<style scoped>

</style>